































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator'
import store from '@/store'
import { SelectedTemplate, User } from '@/types/frontend'
import * as db from '@shared/types/database'
import loadingGif from '@/assets/img/loading.gif'
import TemplateManager, { Location } from '@/components/Templates/TemplateManager.vue'
import MetaHeader from '@/components/TestDetails/MetaHeader/MetaHeader.vue'
import TestTitleInput from '@/components/TestDetails/DefaultTestCreation/TestTitleInput.vue'
import TestObjectiveInput from '@/components/TestDetails/DefaultTestCreation/TestObjectiveInput.vue'
import CompletionCounter from '@/components/TestDetails/DefaultTestCreation/CompletionCounter.vue'
import TestDetailsHeaderActions from '@/components/TestDetails/TestDetailsHeaderActions.vue'
import AudienceSelect from '@/components/TestDetails/DefaultTestCreation/AudienceSelect.vue'
import { PresetTestMessages } from '@/store/modules/notification-store-module'
import { Card, Pill } from '@alpha/ink'
import Comments from '@/components/Comments/Comments.vue'
import {
  arePrototypesValid,
  convertAndSaveLegacyTestTitle,
  generateTestCrumbs,
  hasVideoAssets,
  livechartsEnabled
} from '@/utilities/test-helpers'
import TestTypeSelection from '@/components/TestDetails/DefaultTestCreation/TestTypeSelection.vue'
import ClassicTestContent from '@/components/TestDetails/ClassicTestContent.vue'
import ValidatedSection from '@/components/TestDetails/DefaultTestCreation/ValidatedSection.vue'
import DefaultDraftAudienceInfo from '@/components/TestDetails/DefaultTestCreation/DefaultDraftAudienceInfo.vue'
import { processAudience } from '@/utilities/audience-mappers'
import TaggedCard from '@/components/TestDetails/DefaultTestCreation/TaggedCard.vue'
import { mixins } from 'vue-class-component'
import AdminRouteCheck from '@/mixins/AdminRouteCheck.vue'
import SetToastMessage from '@/mixins/SetToastMessage.vue'
import Feedback from '@/components/TestDetails/Feedback.vue'
import AutomatedInsights, { AutomatedInsightObj } from '@/components/Survey/AutomatedInsights.vue'
import { sharedViewRouteName } from '@/router'
import CompletedTest from '@/components/TestDetails/CompletedTest.vue'
import RelatedTests from '@/components/TestDetails/RelatedTests.vue'
import Reports from '@/components/TestDetails/Reports.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import TestGetters from '@/mixins/TestGetters.vue'
import AudienceManagerModal, { getSelectableAudiences } from '@/components/AudienceBuilder/AudienceManagerModal.vue'
import Audience from '@/components/AudienceBuilder/Audience'
import api from '@/api'

@Component({
  components: {
    Breadcrumbs,
    TestTypeSelection,
    TestObjectiveInput,
    TestTitleInput,
    MetaHeader,
    CompletionCounter,
    TestDetailsHeaderActions,
    TemplateManager,
    AudienceSelect,
    ClassicTestContent,
    Comments,
    Feedback,
    RelatedTests,
    Reports,
    CompletedTest,
    Card,
    Pill,
    DefaultDraftAudienceInfo,
    TaggedCard,
    ValidatedSection,
    AutomatedInsights,
    AudienceManagerModal
  }
})
export default class DefaultDraftState extends mixins(AdminRouteCheck, SetToastMessage, TestGetters) {
  @Prop({ required: true }) users!: User[]
  @Prop({ required: true }) followers!: User[]

  numberOfSteps = 3
  showAudienceManagerModal = false
  loading = true
  success = false
  loadingGif = loadingGif
  location = Location.DefaultDraftTestCreation
  pendingAudience: Partial<db.Audience> | null = null
  removingAudience = false
  selectedTemplate: SelectedTemplate = null

  async created () {
    await convertAndSaveLegacyTestTitle(this.test, this.testId, this.workspaceId)
  }

  async mounted () {
    this.loading = true
    await store.dispatch.testCreation.loadWorkspace(this.workspaceId)

    if (this.projectId) {
      store.commit.testCreation.setProjectId(this.projectId)
    }

    await this.setSelectedTemplate()

    if (this.test?.payload.prototypes) {
      store.commit.testCreation.setPrototypes(this.testAssets)
    }

    const payload = { workspaceId: this.workspaceId, testId: this.testId }
    const success = await store.dispatch.survey.fetchSurvey(payload)
    if (success) {
      await store.dispatch.surveyConfiguration.fetchTestConfigurations(payload).catch(console.error)
    }
    this.success = success
    this.loading = false
  }

  get template () {
    return this.selectedTemplate?.template || null
  }

  get TestStatus () {
    return db.TestStatus
  }

  get workspaceId () {
    return this.$route.params.workspaceId
  }

  get projectId () {
    return this.$route.params.projectId
  }

  get accountId () {
    return store.state.workspace.accountId
  }

  get project () {
    if (this.projectId) {
      return store.getters.workspace.getProjectById(this.projectId)
    }
    return undefined
  }

  get showTestResults () {
    if (hasVideoAssets(this.test)) return true
    return this.status === db.TestStatus.Complete || (this.status === db.TestStatus.InProgress && this.isAdmin)
  }

  @Watch('selectedTemplateId')
  async setSelectedTemplate () {
    if (this.selectedTemplateId === -1) {
      this.selectedTemplate = { template: { id: -1 }, templateValues: null }
    } else {
      const template = await api.getTemplateById(this.selectedTemplateId!.toString(), this.accountId!)
      const templateValues = this.test?.payload.templateFieldValues ?? null
      this.selectedTemplate = { template, templateValues }
    }
  }

  get selectedTemplateId () {
    return this.test?.payload.testTemplateId ?? -1
  }

  get audienceId () {
    return this.test?.payload.segment?.id
  }

  get audience () {
    return this.testAudienceInfo ? store.getters.workspace.getAudienceById(this.testAudienceInfo.id) : null
  }

  get processedAudience () {
    if (!this.audience) return null
    return processAudience(this.audience)
  }

  get isTestObjectiveValid () {
    return this.testObjective ? this.testObjective.length > 0 : false
  }

  get isTestAudienceValid () {
    return this.testAudienceInfo
      ? this.testAudienceInfo.id.length > 0 && this.testAudienceInfo.title.length > 0
      : false
  }

  get isTestContentValid () {
    if (this.testType === 'Template') {
      return store.getters.testCreation.testValidForSubmission
    } else {
      return this.customerQuestions?.length > 0 &&
          arePrototypesValid(this.testAssets)
    }
  }

  get completedStepCount () {
    return [
      this.isTestObjectiveValid,
      this.isTestAudienceValid,
      this.isTestContentValid
    ].filter(Boolean).length
  }

  get canAddToQueue () {
    return this.completedStepCount === this.numberOfSteps
  }

  get canClone () {
    if (this.test?.payload.testType !== 'Template') {
      return true
    }
    if (this.selectedTemplate?.template?.hidden === true || !this.selectedTemplate?.template) {
      return false
    } else {
      return true
    }
  }

  get livechartsEnabled () {
    return livechartsEnabled(this.test, this.queryOverride)
  }

  get selectableAudiences () {
    return getSelectableAudiences(store.getters.workspace.workspaceAudiences)
  }

  async setAudience (audience: Pick<Audience, 'id' | 'name'> | null) {
    if (!audience) {
      this.removingAudience = true
      await this.updateTest({ segment: { id: '', title: '' } })
      this.removingAudience = false
      return
    }
    const pendingAudience = store.getters.workspace.getAudienceById(audience.id)
    if (pendingAudience) {
      this.pendingAudience = processAudience(pendingAudience)
    }
    await this.updateTest({ segment: { id: audience.id, title: audience.name } })
    this.pendingAudience = null
  }

  get revertToDraftTag () {
    if (this.status === db.TestStatus.InReview) {
      return 'Must REVERT TO DRAFT to edit'
    } else {
      return null
    }
  }

  get showCompletionCounter () {
    return this.isTestInReview || this.isTestDraft
  }

  get showResults () {
    return this.isTestComplete && this.livechartsEnabled
  }

  get mainInsights (): AutomatedInsightObj[] {
    return store.getters.survey.insights
      .filter(i => {
        const config = store.getters.surveyConfiguration.questionConfigById(i.questionId)
        const showInsight = !this.publicView || (this.publicView && config.visible)
        return i.type === 'Main' && showInsight
      })
      .map(i => ({
        ...i,
        question: store.getters.survey.questionById(i.questionId)!,
        config: store.getters.surveyConfiguration.questionConfigById(i.questionId)
      }))
      .sort((aInsight, bInsight) => {
        return aInsight.question.displayOrder! - bInsight.question.displayOrder!
      })
  }

  get publicView () {
    return this.$route.name === sharedViewRouteName
  }

  hasFeature (feature: string): boolean {
    return !!store.getters.feature.hasFeature(feature)
  }

  get shouldShowFeedback () {
    if (!this.hasFeature('testFeedbackBox')) return false

    if (this.status !== db.TestStatus.Complete) return false

    const userIds = this.test?.payload.feedback
    if (userIds == null) return true

    const hasUserGivenFeedback = Object.keys(userIds).includes(this.authenticatedUser.uid)
    return !hasUserGivenFeedback
  }

  selectOrCreateAudience () {
    this.showAudienceManagerModal = true
  }

  get crumbs () {
    return generateTestCrumbs(this.project)
  }

  async updateTest (payload: Partial<db.TestPayload>) {
    const test = await store.dispatch.workspace.updateTest({
      test: payload,
      workspaceId: this.workspaceId,
      testId: this.test!.id.toString()
    })
    if (!test) {
      this.toast = PresetTestMessages.updateFail
    } else {
      this.toast = PresetTestMessages.updateSuccess
    }
  }
}
